<select class="input minimal" (change)="addPermitTypeFilter($event)" [value]="SelectedPermitType">
  <option value="" style="color:gray">No Permit Type Filter</option>
  @for (i of PermitTypes; track i) {
    <option [selected]="ParkingPermitTypeSelected(i)" [value]="i.Id.toString()">{{i.Name}}
    </option>
  }
</select>
